export default __webpack_public_path__ + "static/media/br_02.664f67cb.jpg";